import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { config } from 'src/config';

const API_BASE_URL: string =
  config.apiBaseUrl[environment.env as keyof typeof config.apiBaseUrl];

@Injectable({
  providedIn: 'root',
})
export class HttpClientService {
  constructor(private http: HttpClient) {}

  createHeader(headers: HttpHeaders) {
		headers.append('Access-Control-Allow-Headers', 'Content-Type');
		headers.append('Access-Control-Allow-Methods', 'GET');
		headers.append('Access-Control-Allow-Origin', '*');
	}

  get(url: string, params?: any) {
    let headers = new HttpHeaders();
		this.createHeader(headers);
    return this.http.get(API_BASE_URL + url, {
      params,
    });
  }

  post(url: string, data: any, options?:any) {
    let headers = new HttpHeaders();
		this.createHeader(headers);
    return this.http.post(API_BASE_URL + url, data, options);
  }

  put(url: string, data: any) {
    let headers = new HttpHeaders();
		this.createHeader(headers);
    return this.http.put(API_BASE_URL + url, data, {});
  }

  remove(url: string, params?: any) {
    let headers = new HttpHeaders();
		this.createHeader(headers);
    return this.http.delete(API_BASE_URL + url, {
      params,
    });
  }

  patch(url: string, data: any) {
    let headers = new HttpHeaders();
		this.createHeader(headers);
    return this.http.patch(API_BASE_URL + url, data, {});
  }
}
